import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const ContentWrapper = styled.div`
  padding: 3em 1em;
  height: 100vh;
  box-sizing: border-box;
  text-align: center;
  svg {
    max-height: 50px;
    max-width: 100%;
  }
  h1 {
    font-size: 8em;
    margin-bottom: 0.5em;
    margin-top: 0.3em;
    @media all and (max-width: 576px) {
      font-size: 6em;
      margin: 0.5em 0.3em;
    }
  }
`;

const NotFoundPage = () => (
  <ContentWrapper>
    {global.theme.logo}
    <h1>404</h1>
    <p>We couldn’t find this page.</p>
    <p>Maybe it’s out there, somewhere...</p>
    <p>
      <Link to="/">Back to homepage</Link>
    </p>
  </ContentWrapper>
);

export default NotFoundPage;
